import type { Maybe } from './types';
import type { GetOrCreateCustomerResponse } from '@/interfaces/revenueCat';

import { revenueCatService } from '@/services/revenueCatAPI';
import { findSubscriptionBy } from './pro-web-helper';

export const iapCountries = [
	'AT',
	'AU',
	'BE',
	'BG',
	'CA',
	'CH',
	'CZ',
	'DE',
	'DK',
	'EE',
	'ES',
	'GB',
	'GR',
	'FI',
	'FR',
	'HR',
	'HU',
	'IE',
	'IT',
	'LV',
	'LT',
	'NZ',
	'NL',
	'PL',
	'PT',
	'RO',
	'SK',
	'SE',
	'US',
	'ZA',

	'IN',
	'EG',
	'PH',
	'GB',
];

export async function getOrCreateSubscriber(jwId: Maybe<string>): Promise<GetOrCreateCustomerResponse | null> {
	try {
		if (jwId == null) return null;

		return await revenueCatService.getSubscriber(jwId);
	} catch {
		return null;
	}
}

export async function updatePremiumStatus(jwId: Maybe<string>) {
	let newPremiumStatus = false;

	const purchaserInfo = await getOrCreateSubscriber(jwId);

	if (purchaserInfo) {
		const expireDate = purchaserInfo.subscriber?.entitlements['Pro']?.expires_date;

		if (expireDate) {
			newPremiumStatus = new Date(expireDate).getTime() > Date.now();
		} else {
			const product_identifier = purchaserInfo.subscriber?.entitlements['Pro']?.product_identifier;
			newPremiumStatus = findSubscriptionBy('id', product_identifier)?.timeframe === 'one time';
		}
	}

	const subscriptionId = newPremiumStatus ? purchaserInfo?.subscriber?.entitlements['Pro']?.product_identifier : null;

	return { newPremiumStatus, subscriptionId };
}
